/**
 * @generated SignedSource<<35d8884981260135b6524a66af764923>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateOpportunityStageBandsInput = {
  bands: ReadonlyArray<OpportunityStageBandInput>;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type OpportunityStageBandInput = {
  name: string;
  endPercentage: number;
  winProbability: number;
};
export type updateOpportunityStageBandsMutationModernMutation$variables = {
  input: UpdateOpportunityStageBandsInput;
};
export type updateOpportunityStageBandsMutationModernMutation$data = {
  readonly updateOpportunityStageBands: {
    readonly company: {
      readonly " $fragmentSpreads": FragmentRefs<"opportunityStageBandsCompany_company">;
    } | null;
  } | null;
};
export type updateOpportunityStageBandsMutationModernMutation = {
  variables: updateOpportunityStageBandsMutationModernMutation$variables;
  response: updateOpportunityStageBandsMutationModernMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateOpportunityStageBandsMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateOpportunityStageBandsPayload",
        "kind": "LinkedField",
        "name": "updateOpportunityStageBands",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "opportunityStageBandsCompany_company"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateOpportunityStageBandsMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateOpportunityStageBandsPayload",
        "kind": "LinkedField",
        "name": "updateOpportunityStageBands",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                  }
                ],
                "concreteType": "OpportunityStageBandTypeConnection",
                "kind": "LinkedField",
                "name": "opportunityStageBands",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OpportunityStageBandTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OpportunityStageBand",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startPercentage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endPercentage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "winProbability",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "opportunityStageBands(first:1000)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e2ed125d8a8353ee677934611410ddf6",
    "id": null,
    "metadata": {},
    "name": "updateOpportunityStageBandsMutationModernMutation",
    "operationKind": "mutation",
    "text": "mutation updateOpportunityStageBandsMutationModernMutation(\n  $input: UpdateOpportunityStageBandsInput!\n) {\n  updateOpportunityStageBands(input: $input) {\n    company {\n      ...opportunityStageBandsCompany_company\n      id\n    }\n  }\n}\n\nfragment opportunityStageBandsCompany_company on Company {\n  id\n  opportunityStageBands(first: 1000) {\n    edges {\n      node {\n        id\n        name\n        startPercentage\n        endPercentage\n        winProbability\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "aa8cc838ae5c45e9094706b8e18493e2";

export default node;
